// removed by extract-text-webpack-plugin
module.exports = {"categories":"Categories__categories___2W8B-","categoriesItem":"Categories__categoriesItem___3MX0x"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/candidate/signUpMarketing/components/Categories.scss
// module id = 1791
// module chunks = 0